import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-12 md:py-20 bg-dark-800 relative overflow-hidden" data-id="element-68">
      <div className="absolute inset-0 bg-gradient-to-t from-dark-900 to-transparent pointer-events-none" data-id="element-69" />

      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto" data-id="element-71">
          <h2 className="text-2xl md:text-5xl font-display text-white uppercase tracking-wide mb-5 md:mb-8 leading-tight" data-id="element-72">
            No dejes pasar esta oportunidad
          </h2>

          <div className="flex items-center justify-center gap-3 mb-5" data-id="element-73">
            <span className="text-gray-500 line-through text-lg md:text-2xl font-display" data-id="element-74">
              $157.990
            </span>
            <span className="bg-red-500/10 text-red-400 border border-red-500/20 px-2.5 py-0.5 rounded-full text-[10px] md:text-xs font-bold uppercase tracking-wider" data-id="element-75">
              Ahorrás $108.000
            </span>
          </div>

          <div className="text-5xl md:text-6xl font-display text-gold-500 tracking-tight mb-6 md:mb-8" data-id="element-76">
            $49.990
          </div>

          <Button className="w-full md:w-auto text-base md:text-xl py-4 md:py-6 px-6 md:px-12 mb-5 shadow-xl" data-id="element-77">
            💥 QUIERO MI NEGOCIO LISTO AHORA
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-3 md:gap-5 text-[10px] md:text-sm text-gray-400 font-medium" data-id="element-78">
            <span className="flex items-center gap-1" data-id="element-79">
              <LockIcon size={12} className="text-gold-500" data-id="element-80" /> Pago seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-81">
              <ShieldCheckIcon size={12} className="text-gold-500" data-id="element-82" /> Acceso en
              5 min
            </span>
            <span className="flex items-center gap-1" data-id="element-83">
              <ShieldCheckIcon size={12} className="text-gold-500" data-id="element-84" /> Garantía 7
              días
            </span>
            <span className="text-white" data-id="element-85">Mercado Pago</span>
          </div>
        </motion.div>
      </div>
    </section>;
}